module.exports = __webpack_public_path__ + "static/ch-him2-lp-quiz-5-cd4f607e1b2ad5b321e5ede057fb566d.jpg";